export const columns = [
    {
        title: '',
        dataIndex: 'title',
        width: '35%',
    },
    {
        title: '',
        dataIndex: 'value',
    },
]


export const lengthColumns = [
    {
        title: '',
        dataIndex: 'title',
        width: '35%',
    },
    {
        title: 'Words',
        dataIndex: 'words',
        width: '10%',
    },
    {
        title: 'Characters',
        dataIndex: 'characters',
    },
]

export const keyValueColumns = [
    {
        title: '',
        dataIndex: 'title',
        width: '15%',
    },
    {
        title: '',
        dataIndex: 'value',
    },
]

export const processedDataInfoColumns = [
    {
        title: '# Raw Entries',
        dataIndex: 'num_rows_entries',
        width: '15%',
    },
    {
        title: '# Rows After Dedup',
        dataIndex: 'after_dedup',
    },
    {
        title: '# Rows changed due to PII',
        dataIndex: 'num_changes_pii',
    },
    {
        title: '# Rows changed due to Decontamination',
        dataIndex: 'num_changes_decontamination',
    },
]

export const examplesColumns = [
    {
        title: <div>Question_id <span style={{ fontWeight: 'bold' }}>(ID)</span></div>,
        dataIndex: 'question_id',
    },
    {
        title: 'question',
        dataIndex: 'question',

    },
    {
        title: 'answer_id',
        dataIndex: 'answer_id',
        width: '0',
    },
    {
        title: 'answer',
        dataIndex: 'answer',
        width: '20%',
    },
    {
        title: 'option 1',
        dataIndex: 'option_1',
        width: '15%',
    },
    {
        title: 'option 2',
        dataIndex: 'option_2',
        width: '15%',
    },
    {
        title: 'level',
        dataIndex: 'level',
        width: '10%',
    },
]